/**
 * Tiny inline Highcharts sparkline used by `ListWidgetComponent`. Each list
 * row passes its own data + color via `x-data="listSparkline({...})"` and
 * triggers `render()` from `x-init`.
 *
 * Highcharts is loaded by the widget blade (see `@@vite('highcharts.js')`) and
 * exposed at `window.Highcharts`. We bail out quietly if it hasn't arrived yet
 * so the rest of the row still renders.
 */
export default function listSparkline(config) {
    return {
        chart: null,
        data: config.data || [],
        color: config.color || '#697077',

        render() {
            if (!window.Highcharts || this.data.length < 2) {
                return;
            }

            this.chart = window.Highcharts.chart(this.$refs.container, {
                chart: {
                    type: 'areaspline',
                    backgroundColor: 'transparent',
                    margin: [2, 2, 2, 2],
                    spacing: [2, 2, 2, 2],
                    animation: false,
                    skipClone: true,
                },
                title: { text: null },
                credits: { enabled: false },
                legend: { enabled: false },
                xAxis: { visible: false, startOnTick: false, endOnTick: false },
                yAxis: { visible: false, startOnTick: false, endOnTick: false },
                tooltip: { enabled: false },
                exporting: { enabled: false },
                plotOptions: {
                    series: {
                        animation: false,
                        marker: { enabled: false, states: { hover: { enabled: false } } },
                        states: { hover: { enabled: false }, inactive: { opacity: 1 } },
                        enableMouseTracking: false,
                    },
                },
                series: [
                    {
                        type: 'areaspline',
                        data: this.data,
                        color: this.color,
                        lineWidth: 1.5,
                        fillOpacity: 0.15,
                    },
                ],
            });
        },
    };
}
